export const DISTRIBUTION_UNIFORM = 'Uniform' as const;
export const DISTRIBUTION_FRONT = 'Front' as const;
export const DISTRIBUTION_BACK = 'Back' as const;
export const DISTRIBUTION_NORMAL = 'Normal' as const;
export const DISTRIBUTION_METHODS = [DISTRIBUTION_UNIFORM, DISTRIBUTION_FRONT, DISTRIBUTION_BACK, DISTRIBUTION_NORMAL];
